import { render } from "./Media.vue?vue&type=template&id=19aa3e50"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"

import "./Media.vue?vue&type=style&index=0&id=19aa3e50&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__